"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dnpColumnFixtureSchema = exports.dnpColumnFixtureExpectationSchema = exports.dnpColumnFixtureModuleSchema = void 0;
const zod_1 = require("zod");
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const dnp_column_decision_1 = require("./dnp-column-decision");
exports.dnpColumnFixtureModuleSchema = zod_1.z.object({
    referenceDesignator: zod_1.z.string(),
    isDnp: zod_1.z.boolean().optional(),
    metadata: sigma_engine_shared_1.DesignModels.MetadataSchema,
});
exports.dnpColumnFixtureExpectationSchema = zod_1.z.object({
    decision: dnp_column_decision_1.dnpColumnDecisionSchema,
    dnpReferenceDesignators: zod_1.z.array(zod_1.z.string()),
});
exports.dnpColumnFixtureSchema = zod_1.z.object({
    name: zod_1.z.string(),
    description: zod_1.z.string(),
    cadTool: sigma_engine_shared_1.DesignModels.CadToolSchema,
    expectedAnswerConfirmed: zod_1.z.boolean(),
    modules: zod_1.z.array(exports.dnpColumnFixtureModuleSchema),
    expected: exports.dnpColumnFixtureExpectationSchema.optional(),
});
//# sourceMappingURL=dnp-column-fixture.js.map